import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const LandingPage = lazy(() =>
  import("./pages/LandingPage").then((m) => ({ default: m.LandingPage }))
);
const CustomerMenuPage = lazy(() =>
  import("./pages/menu/CustomerMenuPage").then((m) => ({
    default: m.CustomerMenuPage,
  }))
);
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((m) => ({
    default: m.NotFoundPage,
  }))
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/menu/:partnerId/:tableId"
            element={<CustomerMenuPage />}
          />
          <Route
            path="/:partnerId/:tableId"
            element={<CustomerMenuPage />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
